import CourseProgress from 'pages/open-course/common/models/courseProgress';

import courseProgressData from 'bundles/catalogP/data/courseProgress';
import createLinkedModels from 'bundles/catalogP/lib/createLinkedModels';
import * as CourseProgressCache from 'bundles/ondemand/stores/CourseProgressCache';

export default function (options: $TSFixMe, memoizeOptions: $TSFixMe) {
  return courseProgressData(options, memoizeOptions).then(function (data) {
    CourseProgressCache.invalidateCache(options.id);
    const localProgressData = CourseProgressCache.readProgressFromLocalStorage(options.id);
    const mergedWithLocalData = CourseProgressCache.mergeProgressFromLocalStorage(data, localProgressData);

    return {
      courseProgress: createLinkedModels(CourseProgress.prototype.resourceName, mergedWithLocalData).first(),
      rawCourseProgress: mergedWithLocalData,
    };
  });
}
